export default __webpack_public_path__ + "static/media/features.5d09afd8.svg";